// kyu-player/music/audioManager.js
// 全局音频管理器 - 与 Vuex store 集成的单例

let audioInstance = null;
let storeRef = null;
let inited = false;
let lastPlayIndex = -1; // 记录上次播放的索引，避免重复设置 src

const fallbackMusicList = [];

export function initAudioManager(store) {
  if (inited) return;
  inited = true;
  storeRef = store;

  if (!audioInstance) {
    audioInstance = new Audio();
    const storeVolume = storeRef && storeRef.state && storeRef.state.music && storeRef.state.music.volume !== undefined ? storeRef.state.music.volume : 50;
    try { audioInstance.volume = storeVolume / 100; } catch (e) {}
  }

  audioInstance.addEventListener('play', () => {
    if (storeRef && storeRef.commit) {
      try { storeRef.commit('music/SET_IS_PLAYING', true); } catch (e) {}
    }
  });

  audioInstance.addEventListener('pause', () => {
    if (storeRef && storeRef.commit) {
      try { storeRef.commit('music/SET_IS_PLAYING', false); } catch (e) {}
    }
  });

  audioInstance.addEventListener('ended', () => {
    let mode = 0;
    let curIdx = 0;
    try {
      if (storeRef && storeRef.state && storeRef.state.music) {
        mode = storeRef.state.music.playMode || 0;
        curIdx = storeRef.state.music.currentIndex || 0;
      }
    } catch (e) {}
    if (mode === 1) {
      // 单曲循环
      if (audioInstance) {
        audioInstance.currentTime = 0;
        audioInstance.play().catch(() => {});
      }
    } else {
      next();
    }
  });

  audioInstance.addEventListener('timeupdate', () => {
    if (storeRef && storeRef.commit && audioInstance && !isNaN(audioInstance.duration) && audioInstance.duration > 0) {
      try {
        storeRef.commit('music/SET_CURRENT_TIME', audioInstance.currentTime || 0);
        storeRef.commit('music/SET_DURATION', audioInstance.duration || 0);
      } catch (e) {}
    }
  });

  audioInstance.addEventListener('loadedmetadata', () => {
    if (storeRef && storeRef.commit && audioInstance) {
      try {
        storeRef.commit('music/SET_DURATION', audioInstance.duration || 0);
      } catch (e) {}
    }
  });

  audioInstance.addEventListener('error', () => {
    // 播放失败时把播放状态置为 false
    if (storeRef && storeRef.commit) {
      try { storeRef.commit('music/SET_IS_PLAYING', false); } catch (e) {}
    }
  });
}

export function getAudio() { return audioInstance; }
export function getStore() { return storeRef; }

export function getMusicList() {
  try {
    return storeRef && storeRef.state && storeRef.state.music && storeRef.state.music.musicList && storeRef.state.music.musicList.length
      ? storeRef.state.music.musicList
      : fallbackMusicList;
  } catch (e) { return fallbackMusicList; }
}

// 设置播放列表（从 HomeMusic.vue 调用）
export function setMusicList(list) {
  if (!storeRef || !storeRef.commit) return;
  try {
    storeRef.commit('music/SET_MUSIC_LIST', list || []);
    storeRef.commit('music/SET_CURRENT_INDEX', -1);
    storeRef.commit('music/SET_CURRENT_SONG', {});
    storeRef.commit('music/SET_IS_PLAYING', false);
    storeRef.commit('music/SET_SHOW_FLOATING', true);
    lastPlayIndex = -1;
  } catch (e) {}
}

export function play(indexOrUrl) {
  if (!audioInstance) { audioInstance = new Audio(); }
  const list = getMusicList();

  if (typeof indexOrUrl === 'number') {
    const track = list[indexOrUrl];
    if (track) {
      const url = track.url;
      if (storeRef && storeRef.commit) {
        try {
          storeRef.commit('music/SET_CURRENT_INDEX', indexOrUrl);
          storeRef.commit('music/SET_CURRENT_SONG', track);
          storeRef.commit('music/SET_DURATION', 0);
          storeRef.commit('music/SET_CURRENT_TIME', 0);
          storeRef.commit('music/SET_SHOW_FLOATING', true);
        } catch (e) {}
      }
      if (url) {
        if (lastPlayIndex !== indexOrUrl) {
          audioInstance.src = url;
          lastPlayIndex = indexOrUrl;
        }
        audioInstance.play().then(() => {
          if (storeRef && storeRef.commit) {
            try { storeRef.commit('music/SET_IS_PLAYING', true); } catch (e) {}
          }
        }).catch(() => {
          if (storeRef && storeRef.commit) {
            try { storeRef.commit('music/SET_IS_PLAYING', false); } catch (e) {}
          }
        });
      } else {
        if (storeRef && storeRef.commit) {
          try { storeRef.commit('music/SET_IS_PLAYING', false); } catch (e) {}
        }
      }
    }
  } else if (typeof indexOrUrl === 'string' && indexOrUrl) {
    audioInstance.src = indexOrUrl;
    audioInstance.play().catch(() => {});
  } else if (list && list.length > 0) {
    const track = list[0];
    if (track) {
      const url = track.url;
      if (storeRef && storeRef.commit) {
        try {
          storeRef.commit('music/SET_CURRENT_INDEX', 0);
          storeRef.commit('music/SET_CURRENT_SONG', track);
          storeRef.commit('music/SET_IS_PLAYING', true);
          storeRef.commit('music/SET_SHOW_FLOATING', true);
        } catch (e) {}
      }
      if (url) {
        if (lastPlayIndex !== 0) {
          audioInstance.src = url;
          lastPlayIndex = 0;
        }
        audioInstance.play().then(() => {
          if (storeRef && storeRef.commit) {
            try { storeRef.commit('music/SET_IS_PLAYING', true); } catch (e) {}
          }
        }).catch(() => {
          if (storeRef && storeRef.commit) {
            try { storeRef.commit('music/SET_IS_PLAYING', false); } catch (e) {}
          }
        });
      } else {
        if (storeRef && storeRef.commit) {
          try { storeRef.commit('music/SET_IS_PLAYING', false); } catch (e) {}
        }
      }
    }
  }
}

export function pause() {
  if (audioInstance) audioInstance.pause();
  if (storeRef && storeRef.commit) {
    try { storeRef.commit('music/SET_IS_PLAYING', false); } catch (e) {}
  }
}

export function toggle() {
  if (!audioInstance) return;
  if (audioInstance.paused) {
    if (!audioInstance.src) {
      // 如果 src 未设置，尝试播放当前索引歌曲
      const list = getMusicList();
      let curIdx = -1;
      try {
        if (storeRef && storeRef.state && storeRef.state.music) curIdx = storeRef.state.music.currentIndex;
      } catch (e) {}
      if (curIdx >= 0 && list.length > curIdx && list[curIdx] && list[curIdx].url) {
        play(curIdx);
      }
      return;
    }
    audioInstance.play().catch(() => {});
  } else {
    audioInstance.pause();
  }
}

export function next() {
  const list = getMusicList();
  if (!list.length) return;
  let curIdx = 0;
  let mode = 0;
  try {
    if (storeRef && storeRef.state && storeRef.state.music) {
      if (storeRef.state.music.currentIndex !== undefined) curIdx = storeRef.state.music.currentIndex;
      mode = storeRef.state.music.playMode || 0;
    }
  } catch (e) {}
  let nextIdx;
  if (mode === 2) {
    // 随机播放
    do { nextIdx = Math.floor(Math.random() * list.length); } while (nextIdx === curIdx && list.length > 1);
  } else {
    nextIdx = (curIdx + 1) % list.length;
  }
  play(nextIdx);
}

export function prev() {
  const list = getMusicList();
  if (!list.length) return;
  let curIdx = 0;
  let mode = 0;
  try {
    if (storeRef && storeRef.state && storeRef.state.music) {
      if (storeRef.state.music.currentIndex !== undefined) curIdx = storeRef.state.music.currentIndex;
      mode = storeRef.state.music.playMode || 0;
    }
  } catch (e) {}
  let prevIdx;
  if (mode === 2) {
    do { prevIdx = Math.floor(Math.random() * list.length); } while (prevIdx === curIdx && list.length > 1);
  } else {
    prevIdx = (curIdx - 1 + list.length) % list.length;
  }
  play(prevIdx);
}

export function seek(ratio) {
  if (audioInstance && audioInstance.duration && !isNaN(audioInstance.duration)) {
    audioInstance.currentTime = audioInstance.duration * Math.max(0, Math.min(1, ratio));
  }
}

export function setVolume(v) {
  if (audioInstance) {
    const normalized = Math.max(0, Math.min(1, v));
    try { audioInstance.volume = normalized; } catch (e) {}
  }
}

export default {
  initAudioManager,
  getAudio,
  getStore,
  getMusicList,
  play,
  pause,
  toggle,
  next,
  prev,
  seek,
  setVolume
}
